import styled from 'styled-components'

export const SlideBackground = styled.div.attrs({
  className: 'slide-background'
})`
  width: 100%;
  height: 100%;
  user-select: none;
  background: #fff;
`
